import User from '@/types/User.interface'
export default {
    methods: {
        //  Load and Navigate to a tenant
        async goToTenant(tenant_id: number, path: string): Promise<void> {
            /**
             * We attempt to navigate before setting the tenant IF a tenant already exists
             * so we are in a clean state without any query parameters from a previous existing tenant
             * i.e. switching tenants while on users?create=true could cause the mounted() to run again
             */
            //  Get the current route
            const route = this.$router.currentRoute

            // //  Check if an existing tenant is here
            // const existing = store.getters.tenant

            //  Pass any query params to the next route
            const params = route.query

            // Remove goto query param since it is already included in 'path'
            const { goto, ...newParams } = params

            // Set query to be passed to route
            const query = '?' + window.toUrlParams(newParams)

            //  Select our destination path. (if no 'path' we default to inbox)
            const destination = path || '/inbox'

            //  Check if we are already at the destination
            const alreadyThere = destination === route.fullPath

            // //  If we're NOT already there, route to the appropriate path
            // if (!same && existing) this.$router.push(route)

            //  Fetch the tenant
            await this.$store.dispatch('tenantGet', tenant_id)
            
            //  If we didn't route before, we need to route now
            // if (!same && !existing) this.$router.push(route)
            if (!alreadyThere) this.$router.push(destination + query)
        },
        //  Route an authenticated user to the appropriate landing page
        routeLogin(user: User): void {
            //  Fetch the user's tenant memberships
            const memberships = user.memberships

            //  Pass any query params to the next route
            const params = this.$route.query ? `?${window.toUrlParams(this.$route.query)}` : ''

            //  If the user has 0 tenants, route to onboarding path logic, even if they verified their email and phone, they have to do it again due to 2FA
            if (memberships.length === 0) {
                this.$router.push('/register/verify')
            }

            //  If the user has one membership, direct them to the tenant dashboard
            //  Use deep linking param (goto) if available
            else if (memberships.length == 1) this.goToTenant(memberships[0].tenant_id, this.$route.query.goto || null)

            //  If the user has more than one membership, direct them to tenant selection
            else if (memberships.length > 1) this.$router.push(`/memberships${params}`)
        },
        //  Route an semi authenticated user to 2FA workflow, since they are guarenteed to have an account with us already 
        //  no need to check for memberships since they should be registered already
        routeTwoFactor(): void {
            //  Pass any query params to the next route
            const params = this.$route.query ? `?${window.toUrlParams(this.$route.query)}` : ''

            // If user has a membership they need to pass two factor auth before accessing the app
            this.$router.push(`/signin/2fa${params}`)
        }
    }
}